import { GROUP_SETTINGS_DATA_REQUEST_ASYNC } from 'containers/GroupSettings/Table/constants'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { URL_STATE, URL_STATE_CHANGE } from '../List/constants'
import { FETCH_ASSIGNEES_ASYNC } from '../Report/constants'

import { getIsUnclassified, LAST_24_HOURS, REGULAR_FILTERS_CHANGE } from './constants'

export default function () {
  const initialState = {
    regularFilters: {
      detectedByFilter: [],
      includesFilter: [],
      excludesFilter: [],
      assignedToFilter: [],
      resolvedFilter: [],
      dateFilter: getIsUnclassified() ? null : LAST_24_HOURS,
    },
    assignees: [],
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GROUP_SETTINGS_DATA_REQUEST_ASYNC.SUCCESS:
      case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS:
        return {
          ...state,
          regularFilters: {
            ...state.regularFilters,
            dateFilter: getIsUnclassified() ? null : LAST_24_HOURS,
          },
        }
      case URL_STATE_CHANGE: {
        const { urlState } = action.payload
        if (urlState === URL_STATE.UNCLASSIFIED || urlState === URL_STATE.CLASSIFIED) {
          return {
            ...state,
            regularFilters: {
              dateFilter: getIsUnclassified() ? state.regularFilters.dateFilter : LAST_24_HOURS,
              detectedByFilter: [],
              includesFilter: [],
              excludesFilter: [],
              assignedToFilter: [],
              resolvedFilter: [],
            },
          }
        }
        return { ...state }
      }
      case REGULAR_FILTERS_CHANGE:
        if (action.payload.filterType === 'all') {
          return {
            ...state,
            regularFilters: {
              dateFilter: getIsUnclassified() ? null : LAST_24_HOURS,
              detectedByFilter: [],
              includesFilter: [],
              excludesFilter: [],
              assignedToFilter: [],
              resolvedFilter: [],
            },
          }
        } else {
          return {
            ...state,
            regularFilters: {
              ...state.regularFilters,
              [action.payload.filterType]: action.payload.value,
            },
          }
        }
      case FETCH_ASSIGNEES_ASYNC.SUCCESS:
        return {
          ...state,
          assignees: action.payload.data,
        }
      default:
        return state
    }
  }
}
